module.exports = __webpack_public_path__ + "img/team2.074bd900.png";